import { Attr, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { CurrencyCode } from "./currencyCode"

@Model()
export class Currency extends ApplicationRecord {
  public static readonly jsonapiType = "currencies"

  @Attr() public readonly type!: string

  @Attr() public readonly name!: string

  @Attr() public readonly alphaCode!: CurrencyCode

  @Attr() public readonly numericCode!: number

  @Attr() public readonly minorUnitRatio!: number
}
